import React from "react";
import "./style.less";
import AreaCategoryLabel from "./AreaCategoryLabel";
import { useSelector, useDispatch } from "react-redux";
import {
  addCategoryToFilter,
  removeCategoryFromFilter
} from "../../../../../redux/geofence/actions";

const countCategories = category => {
  return (acc, e) => {
    if (e.properties.fenceCategory === category) {
      return acc + 1;
    }
    return acc;
  };
};

const calcAreaOf = category => {
  return (acc, e) => {
    if (e.properties.fenceCategory === category) {
      return acc + e.properties.area;
    }
    return acc;
  };
};

function CategoryFilter() {
  const categoriesToShow = useSelector(
    ({ geofence }) => geofence.filter.categoriesToShow
  );
  const searchQuery = useSelector(
    ({ geofence }) => geofence.filter.searchQuery
  );
  const dispatch = useDispatch();
  const geofences = useSelector(({ geofence }) => geofence.geofences);

  return (
    <div className="CategoryFilter">
      {categoriesToShow === null && !searchQuery ? (
        <div className="LabelContainer">
          <AreaCategoryLabel
            onClick={() => {
              dispatch(addCategoryToFilter("SERVICEABLE_AREA"));
            }}
            count={geofences.reduce(countCategories("SERVICEABLE_AREA"), 0)}
            type="SERVICEABLE_AREA"
            area={geofences.reduce(calcAreaOf("SERVICEABLE_AREA"), 0)}
          />
          <br />
          <AreaCategoryLabel
            onClick={() => {
              dispatch(addCategoryToFilter("BUDDY_BLOCK"));
            }}
            count={geofences.reduce(countCategories("BUDDY_BLOCK"), 0)}
            type="BUDDY_BLOCK"
            area={geofences.reduce(calcAreaOf("BUDDY_BLOCK"), 0)}
          />
          <br />
          <AreaCategoryLabel
            onClick={() => {
              dispatch(addCategoryToFilter("NON_SERVICEABLE_AREA"));
            }}
            count={geofences.reduce(countCategories("NON_SERVICEABLE_AREA"), 0)}
            type="NON_SERVICEABLE_AREA"
            area={geofences.reduce(calcAreaOf("NON_SERVICEABLE_AREA"), 0)}
          />
          <br />
          <AreaCategoryLabel
            onClick={() => {
              dispatch(addCategoryToFilter("WAREHOUSE_FENCE"));
            }}
            count={geofences.reduce(countCategories("WAREHOUSE_FENCE"), 0)}
            type="WAREHOUSE_FENCE"
            area={geofences.reduce(calcAreaOf("WAREHOUSE_FENCE"), 0)}
          />
        </div>
      ) : (
        <div className={`CategoryFilterToggleContainer`}>
          <div style={{ float: "left" }}> Filter by Tags: </div>
          <div
            onClick={() => {
              if (
                categoriesToShow &&
                categoriesToShow.indexOf("SERVICEABLE_AREA") !== -1
              )
                dispatch(removeCategoryFromFilter("SERVICEABLE_AREA"));
              else dispatch(addCategoryToFilter("SERVICEABLE_AREA"));
            }}
            className={`SERVICEABLE_AREA tooltip CategoryFilterToggle ${
              categoriesToShow &&
              categoriesToShow.indexOf("SERVICEABLE_AREA") !== -1
                ? "active"
                : ""
            }`}
          >
            <span className="tooltiptext">Serviceable Area</span>
            <div className="inner-circle"></div>
          </div>
          <div
            onClick={() => {
              if (
                categoriesToShow &&
                categoriesToShow.indexOf("BUDDY_BLOCK") !== -1
              )
                dispatch(removeCategoryFromFilter("BUDDY_BLOCK"));
              else dispatch(addCategoryToFilter("BUDDY_BLOCK"));
            }}
            className={`BUDDY_BLOCK tooltip CategoryFilterToggle ${
              categoriesToShow && categoriesToShow.indexOf("BUDDY_BLOCK") !== -1
                ? "active"
                : ""
            }`}
          >
            <span className="tooltiptext">Buddy Block</span>
            <div className="inner-circle"></div>
          </div>
          <div
            onClick={() => {
              if (
                categoriesToShow &&
                categoriesToShow.indexOf("NON_SERVICEABLE_AREA") !== -1
              )
                dispatch(removeCategoryFromFilter("NON_SERVICEABLE_AREA"));
              else dispatch(addCategoryToFilter("NON_SERVICEABLE_AREA"));
            }}
            className={`NON_SERVICEABLE_AREA tooltip CategoryFilterToggle ${
              categoriesToShow &&
              categoriesToShow.indexOf("NON_SERVICEABLE_AREA") !== -1
                ? "active"
                : ""
            }`}
          >
            <span className="tooltiptext">Non-Serviceable Area</span>
            <div className="inner-circle"></div>
          </div>
          <div
            onClick={() => {
              if (
                categoriesToShow &&
                categoriesToShow.indexOf("WAREHOUSE_FENCE") !== -1
              )
                dispatch(removeCategoryFromFilter("WAREHOUSE_FENCE"));
              else dispatch(addCategoryToFilter("WAREHOUSE_FENCE"));
            }}
            className={`WAREHOUSE_FENCE tooltip CategoryFilterToggle ${
              categoriesToShow &&
              categoriesToShow.indexOf("WAREHOUSE_FENCE") !== -1
                ? "active"
                : ""
            }`}
          >
            <span className="tooltiptext">Warehouse fences</span>
            <div className="inner-circle"></div>
          </div>
        </div>
      )}
    </div>
  );
}

CategoryFilter.defaultProps = {};

CategoryFilter.propTypes = {};

export default CategoryFilter;
